@if (requestForm | async; as requestForm) {

<lib-form-validity-dot [control]="requestForm" />

<div class="first-row">
	<lib-form-component-group
		[group]="appService.getGroup('veranstaltung')"
		[options]="appService.formOptions"></lib-form-component-group>

	<lib-form-component-group
		[group]="appService.getGroup('aussteller')"
		[options]="appService.formOptions"></lib-form-component-group>

	<lib-form-component-group
		[group]="appService.getGroup('ansprechpartner')"
		[options]="appService.formOptions"></lib-form-component-group>
</div>

<div class="second-row">
	<lib-form-component-group
		[group]="appService.getGroup('personal')"
		[options]="appService.formOptions"></lib-form-component-group>
</div>

<div class="third-row">
	@if (requestForm.valid) {
	<!-- <span class="success">{{ 'Anforderung an Lorenz Messe senden' | translate }}</span>-->
	<lib-shared-button
		class="primary"
		(click)="submitForm(requestForm, true)">
		{{ 'Anfrage an Lorenz Messe senden' | translate }}
	</lib-shared-button>

	} @else {
	<span class="error">{{ 'Bitte füllen Sie alle notwendigen Formularfelder aus!' | translate }}</span>
	}
</div>
} @else if (appService.requestFormLoadFailed) {
<div
	class="load-failure"
	role="alert">
	<p>{{ 'Das Formular konnte nicht geladen werden. Bitte überprüfe deine Verbindung und versuche es erneut.' | translate }}</p>
	<lib-shared-button
		class="primary"
		(click)="retry()">
		{{ 'Erneut versuchen' | translate }}
	</lib-shared-button>
</div>
}
